// assets
import {
  IconFileInvoice,
  IconCurrencyTaka,
  IconReceiptDollarFilled,
  IconListDetails,
  IconWashMachine,
  IconBooks,
  IconSquarePlus,
  IconGasStation,
  IconChartHistogram,
} from '@tabler/icons-react';

// constant
const icons = {
  IconFileInvoice,
  IconCurrencyTaka,
  IconReceiptDollarFilled,
  IconListDetails,
  IconWashMachine,
  IconBooks,
  IconSquarePlus,
  IconGasStation,
  IconChartHistogram,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  title: 'RO Operation',
  type: 'group',
  access: ['super_admin', 'admin'],
  children: [
    {
      id: 'invoices',
      title: 'Invoices',
      type: 'item',
      color: '#0C356A',
      icon: icons.IconFileInvoice,
      url: '/pages/invoices',
      access: ['super_admin', 'admin'],
    },
    {
      id: 'payment-receipts',
      title: 'Payment receipts',
      type: 'item',
      color: '#0C356A',
      icon: icons.IconReceiptDollarFilled,
      url: '/pages/payment-receipts',
      access: ['super_admin', 'admin'],
    },
    {
      id: 'expenses',
      title: 'Expenses',
      type: 'item',
      color: '#0C356A',
      icon: icons.IconListDetails,
      url: '/pages/expenses',
      access: ['super_admin', 'admin'],
    },
    {
      id: 'fixed-assets',
      title: 'Fixed Assets',
      type: 'item',
      color: '#0C356A',
      icon: icons.IconWashMachine,
      url: '/pages/fixed-assets',
      access: ['super_admin', 'admin'],
    },
    {
      id: 'investments',
      title: 'Investments',
      type: 'item',
      color: '#0C356A',
      icon: icons.IconCurrencyTaka,
      url: '/pages/investments',
      access: ['super_admin', 'admin'],
    },
    {
      id: 'library',
      title: 'Library',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconBooks,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'client-list',
          title: 'Client List',
          type: 'item',
          url: '/pages/library/client-list',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'product-list',
          title: 'Product List',
          type: 'item',
          url: '/pages/library/product-list',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'vendor-list',
          title: 'Vendor List',
          type: 'item',
          url: '/pages/library/vendor-list',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'expense-heads',
          title: 'Expense Heads',
          type: 'item',
          url: '/pages/library/expense-heads',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'expense-sub-heads',
          title: 'Expense Sub-Heads',
          type: 'item',
          url: '/pages/library/expense-sub-heads',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'asset-titles',
          title: 'Asset Titles',
          type: 'item',
          url: '/pages/library/asset-titles',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'report',
      title: 'Report',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconChartHistogram,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'summary',
          title: 'Summary',
          type: 'item',
          url: '/pages/report/summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'daily-report',
          title: 'Daily Report',
          type: 'item',
          url: '/pages/report/daily-report',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'due-report',
          title: 'Due Report',
          type: 'item',
          url: '/pages/report/due-report',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'advance-report',
          title: 'Advance Report',
          type: 'item',
          url: '/pages/report/advance-report',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'expense-summary',
          title: 'Expense Summary',
          type: 'item',
          url: '/pages/report/expense-summary',
          access: ['super_admin', 'admin'],
        },
      ],
    },
  ],
};

export default pages;
